import { baseService } from "service/base";

/*
 * Service for interacting with application versions.
 */
class VersionsService {
  loadAll(params = {}, options = {}) {
    return baseService.get("/api/applications/params", params, options);
  }
}

const versionsService = new VersionsService();

export { versionsService, VersionsService };
